import { createSlice } from '@reduxjs/toolkit';

export const TEXT_BASE_EDITING_SOURCE_TYPE = {
    VIDEO: 'video',
    AUDIO: 'audio',
};

export const FJSliceRightTextBaseEditing = createSlice({
    name: 'rightTextBaseEditing',
    initialState: {
        // 资源源类型
        sourceType: TEXT_BASE_EDITING_SOURCE_TYPE.VIDEO,
        isPlaying: false,

        // 剪辑信息
        trimInfo: {
            start: 0,
            end: 0,
        },

        // 是否空白
        isBlank: true,

        // 选中的时间段列表
        selectTimeList: [],

        // 缩略图blob url
        thumbnailBlobUrl: '',

        // 分割时间列表
        splitTimeList: [],

        // 选中的编辑类型
        selectedType: 'splitted',

        // 是否显示字幕
        isShowSubtitle: false,

        hasUndo: false,
        hasRedo: false,
    },
    reducers: {
        setSliceSourceType: (state, action) => {
            state.sourceType = action.payload;
        },

        setSliceTrimInfo: (state, action) => {
            state.trimInfo = action.payload;
        },

        setSliceSelectTimeList: (state, action) => {
            state.selectTimeList = action.payload;
        },

        setSliceThumbnailBlobUrl: (state, action) => {
            state.thumbnailBlobUrl = action.payload;
        },

        setSliceSplitTimeList: (state, action) => {
            state.splitTimeList = action.payload;
        },

        setSliceIsBlank: (state, action) => {
            state.isBlank = action.payload;
        },

        setSliceIsPlaying: (state, action) => {
            state.isPlaying = action.payload;
        },

        setSliceSelectedType: (state, action) => {
            state.selectedType = action.payload;
        },

        setSliceIsShowSubtitle: (state, action) => {
            state.isShowSubtitle = action.payload;
        },

        setSliceHasUndo: (state, action) => {
            state.hasUndo = action.payload;
        },

        setSliceHasRedo: (state, action) => {
            state.hasRedo = action.payload;
        },
    },
});

export const {
    setSliceSourceType,
    setSliceTrimInfo,
    setSliceSelectTimeList,
    setSliceThumbnailBlobUrl,
    setSliceSplitTimeList,
    setSliceIsBlank,
    setSliceIsPlaying,
    setSliceSelectedType,
    setSliceIsShowSubtitle,
    setSliceHasUndo,
    setSliceHasRedo,
} = FJSliceRightTextBaseEditing.actions;

export default FJSliceRightTextBaseEditing.reducer;
